/* <project-root>/src/worker/app-workers/mocked-cpu-intensive.worker.ts */

import { WorkerMessage } from './shared/worker-message.model';

export class MockedCpuIntensiveWorker {

  constructor() { }

}